var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"about","tag":"section"}},[_c('base-subheading',[_vm._v("About")]),_c('p',[_vm._v(" A fan site for the best integrated amp of the 90's "),_c('tt',[_vm._v(":-)")])],1),_c('p',[_vm._v(" There's also some info on the PMA 260, 360, 860, and 1060 (nothing on the 1560 yet). ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }